import { Operation } from "libs/transaction";
import { createAction } from "./action";
import * as ops from "libs/operations";

/* -------------------------------------------------------------------------------------------------
 *  updateUser
 * -------------------------------------------------------------------------------------------------
 */

type UpdateUserProps = {
  profile?: Omit<ops.user.UpdateUserNameProps, "userId">;
  contactInfo?: Omit<ops.user.UpdateUserContactInfoProps, "userId">;
};

export const updateUser = createAction<UpdateUserProps>("user.updateUser", {
  operations: async (props, context) => {
    const { currentUserId: userId } = context;
    const { profile, contactInfo } = props;

    const operations: Operation[] = [];

    if (profile) {
      ops.applyOperationsToTransaction(
        operations,
        ops.user.updateUserName({
          userId,
          ...profile,
        }),
      );
    }

    if (contactInfo) {
      ops.applyOperationsToTransaction(
        operations,
        ops.user.updateUserContactInfo({
          userId,
          ...contactInfo,
        }),
      );
    }

    return operations;
  },
  authorize: async () => {
    // Users are permitted to update their own profile and contact_info records, and the current implementation
    // with `context.currentUserId` ensures that only this record can be updated, so no authorization is necessary.
  },
});

export const actions = {
  updateUser,
};
